import script from "./BaseChip.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseChip.vue?vue&type=script&setup=true&lang=js"

import "./BaseChip.vue?vue&type=style&index=0&id=773ebce6&lang=scss&scoped=true"
script.__scopeId = "data-v-773ebce6"

export default script